import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { useApiClient } from "../../contexts/ApiClientContext";
import APIEndPoints from "../../utils/APIEndPoints";
import PathInfo from "../../model/PathInfo";
import Annotation from "../../model/Annotation";
import PathDisplay from "../common/PathDisplay";

function Annotations() {
  // read the ID from the url
  const { id } = useParams();
  // store data path
  const [pathInfo, setPathInfo] = useState<PathInfo | undefined>(undefined);
  // reference to the ApiClient instance
  const apiClient = useApiClient();
  // reference to Location, to update path when it changes
  const location = useLocation();

  useEffect(() => {
    const getPathInfo = async () => {
      if (id) {
        const info = await apiClient?.get<Annotation>({
          url: APIEndPoints.ANNOTATIONS.ONE(parseInt(id)),
        });
        setPathInfo(info.parent);
      }
    };
    getPathInfo();
  }, [location]);

  return (
    <div>
      <PathDisplay data={pathInfo!} />
      <Outlet />
    </div>
  );
}

export default Annotations;
